export default __webpack_public_path__ + "static/media/1_quick_text.b371b5ea.svg";